import React from 'react';
import './ApplyPPE.css';

const ApplyPPE = (props: any) => {
	return (
		<div className="ui-container modal-disable-select">
			<button>ApplyPPE</button>
		</div>
	);
};

export default ApplyPPE;
